"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenRatingAndReviewDialog = exports.Name = void 0;
exports.dispatch = dispatch;
const Name = exports.Name = 'open-rating-and-review-dialog';
const OpenRatingAndReviewDialog = exports.OpenRatingAndReviewDialog = Name;
/**
 * Utility for dispatching the open-rating-and-review-dialog event.
 * @param {Data} data data of the event.
 */
function dispatch(data) {
  window.dispatchEvent(new CustomEvent(Name, {
    detail: data
  }));
}
